import { render, staticRenderFns } from "./TeachFuBaodetails.vue?vue&type=template&id=5519705e&scoped=true&"
import script from "./TeachFuBaodetails.vue?vue&type=script&lang=js&"
export * from "./TeachFuBaodetails.vue?vue&type=script&lang=js&"
import style0 from "./TeachFuBaodetails.vue?vue&type=style&index=0&id=5519705e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5519705e",
  null
  
)

export default component.exports